import { cn } from '@cocoonspace/ui/lib/utils'

import { LocalizedLink as Link } from '~/components/localized-link'

export const PoweredBy = ({ alt = false }: { alt?: boolean }) => {
	return (
		<div
			className={cn('mb-auto flex flex-row items-center gap-1', {
				'bg-card/70 rounded p-1 px-3': alt,
			})}
		>
			<div className='text-sm'>Powered by</div>

			<Link
				href='https://scheduling.cocoon-space.com/'
				className='text-primary/80 text-sm font-bold underline'
				target='_blank'
			>
				cocoon space
			</Link>
		</div>
	)
}
